// extracted by mini-css-extract-plugin
export default {"topMenu":"TopMenu_topMenu__B7ACd","moreInfo":"TopMenu_moreInfo__JxFjf","logo":"TopMenu_logo__lF8Ls","menuTrigger":"TopMenu_menuTrigger__78C1W","closed":"TopMenu_closed__VqO6l"};